import Step1 from "../Step1";
import PrequalificationStep from "../PrequalificationStep";
import Step2 from "../Step2";
import Step3 from "../Step3";
import Step3Prequalification from "../Step3Prequalification";
import ConfirmationStep from "../ConfirmationStep";
import NobodyApprovedStep from "../NobodyApprovedStep";
import ProviderHaveNotApprovedStep from "../ProviderHaveNotApprovedStep";
import ErrorStep from "../ErrorStep";
import AdditionalInfoStep from "../AdditionalInfoStep";
import ContractStep from "../ContractStep";
import SuccessStep from "../SuccessStep";
import AlreadyCompletedStep from "../AlreadyCompletedStep";
import VerificationQuestionsStep from "../VerificationQuestionsStep";
import BankDataForm from "../Step3/BankDataForm";
import ProgressiveBankDataForm from "../Step3/ProgressiveOffer/BankDataForm";
import ProgressiveCardDataForm from "../Step3/ProgressiveOffer/CardDataForm";
import ProgressiveDeniedAppScreen from "../Step3/ProgressiveOffer/DeniedScreen";
import ProgressiveAgreement from "../Step3/ProgressiveOffer/Agreement";
import ProgressivePendingAppScreen from '../Step3/ProgressiveOffer/PendingScreen';
import ProgressiveApprovedAppScreen from '../Step3/ProgressiveOffer/ApprovedScreen';
import ProgressiveCustomerLookup from "../ProgressiveCustomerLookup";
import PrequalOfferScreen from "../Step3/ProgressiveOffer/PrequalOfferScreen";
import PrequalApprovedScreen from "../Step3/ProgressiveOffer/PrequalApprovedScreen";
import PrequalPartialScreen from "../Step3/ProgressiveOffer/PrequalPartialScreen";
import PrequalEmploymentForm from "../Step3/ProgressiveOffer/PrequalEmploymentForm";

import KafeneAgreement from "../Step3/KafeneOffer/Agreement";
import KafeneBankDataForm from "../Step3/KafeneOffer/BankDataForm";
import KafeneApprovedAppScreen from "../Step3/KafeneOffer/ApprovedScreen";
import KafeneDeniedAppScreen from "../Step3/KafeneOffer/DeniedScreen";
import KafenePendingAppScreen from "../Step3/KafeneOffer/PendingScreen";
import KafeneOfferDetails from "../Step3/KafeneOffer/OfferDetails";
import KafeneContractView from "../Step3/KafeneOffer/ContractView";
import KafeneStripePayment from "../Step3/KafeneOffer/StripePayment";

import UownBankDataForm from "../Step3/UownOffer/BankDataForm";
import UownUnavailableScreen from '../Step3/UownOffer/UnavailableScreen';

import FypnAdditionalInfoForm from "../Step3/FypnOffer/AdditionalInfoForm";
import FypnCardForm from "../Step3/FypnOffer/CardForm";
import FypnBankDataForm from "../Step3/FypnOffer/BankDataForm";
import FypnIbvFrame from "../Step3/FypnOffer/IbvFrame";
import FypnContract from "../ContractStep/FypnContract";

import GenesisConfirmation1 from "../Genesis/ConfirmationStep1";
import GenesisConfirmation2 from "../Genesis/ConfirmationStep2";

import SnapConfirmation from "../Snap/SnapConfirmation";
import SnapTotalInfo from "../Snap/SnapTotalInfo";
import SnapLeasePayment from "../Snap/SnapLeasePayment";
import SnapPendingScreen from "../Snap/SnapPendingScreen";
import LoaderStep from "../LoaderStep";

export function getForms(multipleIframeEnabled = false) {
  return {
    form1: { breadcrumb: null, form: Step1 },
    prequalification: { breadcrumb: "Application", form: PrequalificationStep },
    progressiveCustomerLookup: { breadcrumb: null, form: ProgressiveCustomerLookup },
    form2: { breadcrumb: null, form: Step2 },
    loader: { breadcrumb: null, form: LoaderStep },
    form3: { breadcrumb: "Decision", form: Step3 },
    step3Prequalification: { breadcrumb: null, form: Step3Prequalification },
    confirmationStep: { breadcrumb: "Confirmation", form: ConfirmationStep },
    nobodyApprovedStep: { breadcrumb: "Decision", form: NobodyApprovedStep },
    providerHaveNotApprovedStep: {
      breadcrumb: "Decision",
      form: ProviderHaveNotApprovedStep,
    },
    errorStep: { breadcrumb: "Decision", form: ErrorStep },
    additionalInfoStep: { breadcrumb: "Decision", form: AdditionalInfoStep },
    bankDataForm: { breadcrumb: "Confirmation", form: BankDataForm },
    progressiveBankData: { breadcrumb: "Confirmation", form: ProgressiveBankDataForm },
    progressiveDeniedAppScreen: { breadcrumb: "Confirmation", form: ProgressiveDeniedAppScreen },
    progressivePendingAppScreen: { breadcrumb: "Confirmation", form: ProgressivePendingAppScreen },
    progressiveApprovedAppScreen: { breadcrumb: "Confirmation", form: ProgressiveApprovedAppScreen },
    progressiveCardData: { breadcrumb: "Confirmation", form: ProgressiveCardDataForm },
    progressiveAgreement: { breadcrumb: "Confirmation", form: ProgressiveAgreement },
    progressivePrequalOffer: { breadcrumb: "Decision", form: PrequalOfferScreen },
    progressivePrequalEmployment: { breadcrumb: "Application", form: PrequalEmploymentForm },
    progressivePrequalApproved: { breadcrumb: "Confirmation", form: PrequalApprovedScreen },
    progressivePrequalPartial: { breadcrumb: "Decision", form: PrequalPartialScreen },
    kafeneAgreement: { breadcrumb: "Confirmation", form: KafeneAgreement },
    kafeneBankData: { breadcrumb: "Confirmation", form: KafeneBankDataForm },
    kafeneApprovedAppScreen: { breadcrumb: "Confirmation", form: KafeneApprovedAppScreen },
    kafeneDeniedAppScreen: { breadcrumb: "Confirmation", form: KafeneDeniedAppScreen },
    kafenePendingAppScreen: { breadcrumb: "Confirmation", form: KafenePendingAppScreen },
    kafeneOfferDetails: { breadcrumb: "Confirmation", form: KafeneOfferDetails },
    kafeneContractView: { breadcrumb: "Confirmation", form: KafeneContractView },
    kafeneStripePayment: { breadcrumb: "Confirmation", form: KafeneStripePayment },
    uownBankDataForm: { breadcrumb: "Confirmation", form: UownBankDataForm },
    uownUnavailableScreen: { breadcrumb: "Confirmation", form: UownUnavailableScreen },
    fypnAdditionalInfoForm: { breadcrumb: "Confirmation", form: FypnAdditionalInfoForm },
    fypnCardForm: { breadcrumb: "Confirmation", form: FypnCardForm },
    fypnBankDataForm: { breadcrumb: "Confirmation", form: FypnBankDataForm },
    fypnIbvFrame: { breadcrumb: "Confirmation", form: FypnIbvFrame },
    fypnContract: { breadcrumb: "Confirmation", form: FypnContract },
    ...(!multipleIframeEnabled && {
      contractStep: { breadcrumb: "Confirmation", form: ContractStep },
    }),
    successStep: { breadcrumb: "Confirmation", form: SuccessStep },
    alreadyCompletedStep: {
      breadcrumb: "Decision",
      form: AlreadyCompletedStep,
    },
    verificationQuestionsStep: {
      breadcrumb: "Decision",
      form: VerificationQuestionsStep,
    },
    genesisConfirmation1: {
      breadcrumb: "Confirmation",
      form: GenesisConfirmation1,
    },
    genesisConfirmation2: {
      breadcrumb: "Confirmation",
      form: GenesisConfirmation2,
    },
    snapConfirmation: { breadcrumb: "Confirmation", form: SnapConfirmation },
    snapTotalInfo: { breadcrumb: "Confirmation", form: SnapTotalInfo },
    snapLeasePayment: { breadcrumb: "Confirmation", form: SnapLeasePayment },
    snapPendingScreen: { breadcrumb: "Confirmation", form: SnapPendingScreen },
  };
}
